import { List } from "immutable";
import { isString } from "lodash";

import { immutableRecords } from "../types";

const makeSelection = (start, end) => immutableRecords.TextSelectionRecord({ start, end });

const selectionOrEnd = (selection, value) =>
  selection ? selection : isString(value) ? makeSelection(value.length, value.length) : null;

const makeMoment = (value, selection) =>
  immutableRecords.LocalUndoMomentRecord({
    value,
    selection: selectionOrEnd(selection, value)
  });

const reset = (value, selection = null) =>
  immutableRecords.LocalUndoStackRecord({
    past: List(),
    present: makeMoment(value, selection),
    future: List()
  });

const moveSelection = (stack, value, selection) => {
  // Only change the selection if the value matches our present value
  // Otherwise, the user has started typing, so we will wait until it comes through as a regular change instead
  return value === stack.present.value ? stack.setIn(["present", "selection"], selection) : stack;
};

const change = (stack, value, selection = null) => {
  // we only apply a change if the value has changed. If we end up with the exact same value, no point cluttering
  // our change history with many repeats of an identical value
  return value !== stack.present.value
    ? stack
      .update("past", past => past.push(stack.present))
      .set("present", makeMoment(value, selection))
      .set("future", List())
    : stack;
};

const undo = stack => {
  return stack.past.size > 0
    ? stack
      .update("future", future => future.unshift(stack.present))
      .set("present", stack.past.last())
      .update("past", past => past.pop())
    : stack;
};

const redo = stack => {
  return stack.future.size > 0
    ? stack
      .update("past", past => past.push(stack.present))
      .set("present", stack.future.first())
      .update("future", future => future.shift())
    : stack;
};

export default {
  makeSelection,
  reset,
  moveSelection,
  change,
  undo,
  redo
};
